<div class="container">
  <img src="assets/images/kids.png" alt="KidsKARTE" width="50%" />
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-field">
      <label for="corpprefix" class="form-field-label">オフィス番号</label>
      <input id="corpprefix" autofocus matInput formControlName="corpprefix" [required]="true" maxlength="90" />
      <ng-container *ngIf="corpprefix.invalid && (corpprefix.dirty || corpprefix.touched)">
        <mat-error *ngIf="corpprefix.hasError('required')">オフィス番号を入力して下さい</mat-error>
      </ng-container>
    </div>
    <div class="form-field">
      <label for="loginid" class="form-field-label">ログインID</label>
      <input type="email" id="loginid" matInput formControlName="username" [required]="true" maxlength="90"
        inputmode="email" />
      <ng-container *ngIf="username.invalid && (username.dirty || username.touched)">
        <mat-error *ngIf="username.hasError('required')">ログインIDを入力して下さい</mat-error>
        <mat-error *ngIf="username.hasError('pattern')">半角英数字記号で入力してください</mat-error>
      </ng-container>
    </div>
    <div class="form-field">
      <label for="password" class="form-field-label">パスワード</label>
      <input type="password" id="password" matInput formControlName="password" [required]="true" maxlength="90" autocomplete=“current-password”/>
      <ng-container *ngIf="password.invalid && (password.dirty || password.touched)">
        <mat-error *ngIf="password.hasError('required')">パスワードを入力して下さい</mat-error>
      </ng-container>
    </div>
    <div class="button-wrap">
      <button mat-button>ログイン</button>
    </div>
  </form>
</div>